"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsTextOverflowing = void 0;
const react_1 = require("react");
const useIsTextOverflowing = (elementRef) => {
    const [isOverflowing, setIsOverflowing] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (elementRef.current) {
            setIsOverflowing(elementRef.current.scrollWidth > elementRef.current.offsetWidth);
        }
    }, [elementRef]);
    return isOverflowing;
};
exports.useIsTextOverflowing = useIsTextOverflowing;
exports.default = exports.useIsTextOverflowing;
